// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.example-container {
    display: flex;
    flex-direction: column;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
  }
  
 mat-card div > * {
    width: 100%;
    text-align: center;
  }

  .green{
      background-color: green;
      color: white;
      font-size: 25px;
  }

  .warning{
    background-color: yellow;
    color: black;
    font-size: 25px;
}

.danger{
    background-color: red;
    color: white;
    font-size: 20px;
}

.tempcheck{
    background-color:#ff8c00;
    color: white;
    font-size: 25px;
}

.blue {
  background-color: #005776;
  color: white;
  font-size: 20px;
}



  @media(max-width:762px){
      .example-container{
          width: 100%;
      }
  }


/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNjcmVlbmluZy1yZXBvcnQuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtJQUNJLGFBQWE7SUFDYixzQkFBc0I7SUFDdEIsVUFBVTtJQUNWLGlCQUFpQjtJQUNqQixrQkFBa0I7RUFDcEI7O0NBRUQ7SUFDRyxXQUFXO0lBQ1gsa0JBQWtCO0VBQ3BCOztFQUVBO01BQ0ksdUJBQXVCO01BQ3ZCLFlBQVk7TUFDWixlQUFlO0VBQ25COztFQUVBO0lBQ0Usd0JBQXdCO0lBQ3hCLFlBQVk7SUFDWixlQUFlO0FBQ25COztBQUVBO0lBQ0kscUJBQXFCO0lBQ3JCLFlBQVk7SUFDWixlQUFlO0FBQ25COztBQUVBO0lBQ0ksd0JBQXdCO0lBQ3hCLFlBQVk7SUFDWixlQUFlO0FBQ25COztBQUVBO0VBQ0UseUJBQXlCO0VBQ3pCLFlBQVk7RUFDWixlQUFlO0FBQ2pCOzs7O0VBSUU7TUFDSTtVQUNJLFdBQVc7TUFDZjtFQUNKIiwiZmlsZSI6InNjcmVlbmluZy1yZXBvcnQuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5leGFtcGxlLWNvbnRhaW5lciB7XHJcbiAgICBkaXNwbGF5OiBmbGV4O1xyXG4gICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcclxuICAgIHdpZHRoOiA4MCU7XHJcbiAgICBtYXJnaW4tbGVmdDogYXV0bztcclxuICAgIG1hcmdpbi1yaWdodDogYXV0bztcclxuICB9XHJcbiAgXHJcbiBtYXQtY2FyZCBkaXYgPiAqIHtcclxuICAgIHdpZHRoOiAxMDAlO1xyXG4gICAgdGV4dC1hbGlnbjogY2VudGVyO1xyXG4gIH1cclxuXHJcbiAgLmdyZWVue1xyXG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiBncmVlbjtcclxuICAgICAgY29sb3I6IHdoaXRlO1xyXG4gICAgICBmb250LXNpemU6IDI1cHg7XHJcbiAgfVxyXG5cclxuICAud2FybmluZ3tcclxuICAgIGJhY2tncm91bmQtY29sb3I6IHllbGxvdztcclxuICAgIGNvbG9yOiBibGFjaztcclxuICAgIGZvbnQtc2l6ZTogMjVweDtcclxufVxyXG5cclxuLmRhbmdlcntcclxuICAgIGJhY2tncm91bmQtY29sb3I6IHJlZDtcclxuICAgIGNvbG9yOiB3aGl0ZTtcclxuICAgIGZvbnQtc2l6ZTogMjBweDtcclxufVxyXG5cclxuLnRlbXBjaGVja3tcclxuICAgIGJhY2tncm91bmQtY29sb3I6I2ZmOGMwMDtcclxuICAgIGNvbG9yOiB3aGl0ZTtcclxuICAgIGZvbnQtc2l6ZTogMjVweDtcclxufVxyXG5cclxuLmJsdWUge1xyXG4gIGJhY2tncm91bmQtY29sb3I6ICMwMDU3NzY7XHJcbiAgY29sb3I6IHdoaXRlO1xyXG4gIGZvbnQtc2l6ZTogMjBweDtcclxufVxyXG5cclxuXHJcblxyXG4gIEBtZWRpYShtYXgtd2lkdGg6NzYycHgpe1xyXG4gICAgICAuZXhhbXBsZS1jb250YWluZXJ7XHJcbiAgICAgICAgICB3aWR0aDogMTAwJTtcclxuICAgICAgfVxyXG4gIH1cclxuXHJcbiJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/screening-report/screening-report.component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,iBAAiB;IACjB,kBAAkB;EACpB;;CAED;IACG,WAAW;IACX,kBAAkB;EACpB;;EAEA;MACI,uBAAuB;MACvB,YAAY;MACZ,eAAe;EACnB;;EAEA;IACE,wBAAwB;IACxB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,YAAY;IACZ,eAAe;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;;;EAIE;MACI;UACI,WAAW;MACf;EACJ;;;AAGF,g1DAAg1D","sourcesContent":[".example-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 80%;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n  }\r\n  \r\n mat-card div > * {\r\n    width: 100%;\r\n    text-align: center;\r\n  }\r\n\r\n  .green{\r\n      background-color: green;\r\n      color: white;\r\n      font-size: 25px;\r\n  }\r\n\r\n  .warning{\r\n    background-color: yellow;\r\n    color: black;\r\n    font-size: 25px;\r\n}\r\n\r\n.danger{\r\n    background-color: red;\r\n    color: white;\r\n    font-size: 20px;\r\n}\r\n\r\n.tempcheck{\r\n    background-color:#ff8c00;\r\n    color: white;\r\n    font-size: 25px;\r\n}\r\n\r\n.blue {\r\n  background-color: #005776;\r\n  color: white;\r\n  font-size: 20px;\r\n}\r\n\r\n\r\n\r\n  @media(max-width:762px){\r\n      .example-container{\r\n          width: 100%;\r\n      }\r\n  }\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
